import { selector, selectorFamily, useRecoilValue } from 'recoil';
import { accountId, isAuthenticated, userInfo } from 'state';
import { AccountInfo } from 'types';

export const accounts = selector<AccountInfo[]>({
    key: 'accounts',
    get: async ({ get }) => {        
        if (get(isAuthenticated)) {
            const user = get(userInfo);
            return user.accounts;
        }
        return [];
    }
});

export const accountInfo = selectorFamily<AccountInfo, string | undefined>({
    key: 'accountInfo',
    get: (id) => ({get}) => {
        const accountList = get(accounts);
        id ??= get(accountId);
        const account = accountList.find((account) => account.accountId === id);
        if (account) {
            return account;
        }
        return {
            accountId: id,
            accountName: '',
            error: 'Not found'
        };
    }
});

export const useAccounts = () => useRecoilValue(accounts);
export const useAccountInfo = (id?: string) => useRecoilValue(accountInfo(id));